/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 12/4/2022 上午 9:10 🚌🚄🚈🚝 */
<template>
	<layout
		:mainTitle="`${className}学生考试`"
		btnName="下载"
		secondTitle="成对比绩分析报告"
		style="position: relative"
		previewState
		@downloadPDF="downloadPDF"
		@preview="preview"
		ref="pdfDom"
	>
		<div class="btn-wrap" v-show="!downState">
			<el-button size="medium" class="handle-btn" @click="subjectVisible = true">选择科目</el-button>
			<el-button size="medium" class="handle-btn" @click="btnChooseClass">选择班级</el-button>
			<el-button size="medium" class="handle-btn" @click="btnChooseStudent">选择学生</el-button>
		</div>
		<div v-if="subjectCode.length && studentIds.length && classIds.length">
			<list
				v-for="item in subjectCode"
				ref="list"
				:key="item.val"
				:basicInfo="query"
				:subjectCode="item.val"
				:subjectName="item.name"
				:studentIds="studentIds"
				:classId="classIds"
			/>
		</div>

		<el-dialog title="选择科目" :visible.sync="subjectVisible" width="70%">
			<el-row>
				<el-radio-group v-model="subjectCurVal" size="mini">
					<el-col :key="item.val" v-for="item in subjectList" :span="6" style="margin-bottom: 20px">
						<el-radio :label="item.val" border @change="selectSubject(item)">{{ item.name }}</el-radio>
					</el-col>
				</el-radio-group>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="subjectVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmSubject">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择班级" :visible.sync="classVisible" width="70%">
			<el-row>
				<el-radio-group v-model="classIds" size="mini">
					<el-col :key="item.val" v-for="item in classList" :span="6" style="margin-bottom: 20px">
						<el-radio :label="item.classId" border @change="selectClass(item)">{{ item.className }}</el-radio>
					</el-col>
				</el-radio-group>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="classVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmClass">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择学生" :visible.sync="studentVisible" width="70%" append-to-body style="overflow-y: auto;">
			<el-row style="max-height: 300px">
				<el-checkbox-group v-model="studentIds" size="mini" @change="selectStudent">
					<el-col :key="item.studentId" v-for="item in studentList" :span="6" style="margin-bottom: 20px">
						<el-checkbox :label="item.studentId" border>{{ item.studentName }}</el-checkbox>
					</el-col>
				</el-checkbox-group>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="studentVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmStudent">确 定</el-button>
			</span>
		</el-dialog>
	</layout>
</template>

<script>
import cookies from '@/utils/cookie'
export default {
	name: 'temp',
	data() {
		return {
			query: this.$route.query,
			classVisible: false,
			subjectVisible: false,
			studentVisible: false,
			subjectList: [],
			subjectCode: [],
			subjectCurVal: '',
			subjectName: '',
			classList: [],
			classIds: '',
			className: '',
			studentList: [],
			studentIds: [],
			downState: false,
			FIRST: 0
		}
	},
	components: {
		layout: () => import('../utils/components/report-layout'),
		list: () => import('./components/list')
	},
	created() {
		cookies.set('token', this.query.token)
		this.$screenRation()
		this.getSubjectList()
	},
	methods: {
		// 获取科目列表
		getSubjectList() {
			const params = {
				examIds: this.query.examIds
			}
			this.$post('/reportApi/queryExamCommonSubjectInfo', params).then(res => {
				let subjectList = []
				for (let key in res.data) {
					subjectList.push({ name: res.data[key], val: key })
				}
				this.subjectList = subjectList
				this.subjectCurVal = subjectList[0].val
				this.subjectCode = [subjectList[0]]
				this.getClassList()
			})
		},
		// 选择科目
		selectSubject(value) {
			this.subjectCurVal = value.val
			this.subjectCode = [value]
		},
		// 选择科目  确定
		confirmSubject() {
			this.subjectVisible = false
		},
		// 班级 dialog true
		btnChooseClass() {
			this.classVisible = true
			this.getClassList()
		},
		//班级列表
		getClassList() {
			const params = {
				examIds: this.query.examIds,
				schoolId: this.query.schoolId,
				subjectCode: this.subjectCurVal
			}
			this.$post('/reportApi/queryExamCommonClassInfo', params).then(res => {
				this.classList = res.data
				this.classIds = res.data[0].classId
				this.className = res.data[0].className
				this.getStudentList()
			})
		},
		// 选择班级
		selectClass(val) {
			this.className = val.className
			this.classIds = val.classId
		},
		// 班级  确定
		confirmClass() {
			this.classVisible = false
			this.setChildMethods()
		},
		//学生 dialog true
		btnChooseStudent() {
			this.studentVisible = true
			this.getStudentList(false)
		},
		// 学生列表
		getStudentList(flag = true) {
			const params = {
				examIds: this.query.examIds,
				schoolId: this.query.schoolId,
				subjectCode: this.subjectCurVal,
				classId: this.classIds
			}
			this.$post('/reportApi/queryExamCommonClassStudent', params).then(res => {
				this.studentList = res.data
				res.data.forEach((ele, index) => {
					if (index < 5 && flag) {
						this.studentIds.push(ele.studentId)
					}
				})
			})
		},
		selectStudent(val) {
			this.studentIds = val
			if (val.length > 10) {
				this.studentIds.pop()
				this.$message.error('最多选5个班级')
				return
			}
		},
		confirmStudent() {
			this.studentVisible = false
			this.setChildMethods()
		},
		setChildMethods() {
			const _this = this
			setTimeout(function() {
				_this.subjectCode.forEach((res, index) => {
					_this.$refs['list'][index].getTableData()
					_this.$refs['list'][index].echartsData()
				})
			})
		},
		downloadPDF() {
			const _this = this
			setTimeout(function() {
				_this.$print(_this.$refs['pdfDom'])
			}, 1000)
		},
		//预览
		preview() {
			this.downState = true
			this.subjectCode = this.subjectList
		}
	}
}
</script>
<style scoped lang="less">
.charts {
	height: 500px;
}

.btn-wrap {
	display: flex;
	justify-content: flex-end;
	position: absolute;
	top: 143px;
	right: 10px;
	.handle-btn {
		background: #009688;
		color: white;
	}
}
</style>
